export default __webpack_public_path__ + "static/media/012-muffin.71cbd86e.svg";